import { render, staticRenderFns } from "./PushIcon.vue?vue&type=template&id=d40e70f8&"
import script from "./PushIcon.vue?vue&type=script&lang=js&"
export * from "./PushIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports